import { api } from './api';

export async function fetchVenues(organisationId) {
    const apiInst = await api();

    const response = await apiInst.get('venues?include=teams.club.logo_image,teams.ageGroup&children=true&organisation_id=' + organisationId);
    return response.data;
}

